export const FILTER_MODAL_ACTION_TYPE = {
  CONFIRM: 'CONFIRM',
  CLICK_OUTSIDE: 'backdrop',
  DRAG_DISMISS: 'gesture',
  TOUCH_CLEAR: 'TOUCH_CLEAR',
  DESKTOP_DISMISS: 'DESKTOP_DISMISS',
};
